import React, { useContext } from 'react';
import {
  KFLDropmenu,
  KFLDropmenugroup,
  KFLButton,
  KFLDropmenuitem,
} from '@kamstrup/kamstrup-frontend-library';
import { ActionButton } from '../../models';
import { TranslateType } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';

const defaultOnClick = () => {};

const buildButton = (item: ActionButton, translate: TranslateType) => (
  <KFLButton
    id={`action-btn-${item.id}`}
    variant="secondary"
    onClick={item.onClick}
  >
    {translate(item.title)}
  </KFLButton>
);

const buildDropDownMenu = (
  items: ActionButton[],
  root: ActionButton,
  translate: TranslateType
) => {
  return (
    <KFLDropmenu
      target={buildButton(root, translate)}
      placement="bottom"
      id={root.id}
    >
      <KFLDropmenugroup>
        {items.map((item) => (
          <span id={`action-btn-${item.id}`} key={`action-btn-${item.id}`}>
            <KFLDropmenuitem
              text={translate(item.title)}
              secondaryText={translate(item.subtitle || '')}
              closeOnClick
              onClick={item.onClick || defaultOnClick}
            />
          </span>
        ))}
      </KFLDropmenugroup>
    </KFLDropmenu>
  );
};

interface OwnProps {
  items: ActionButton[];
  root?: ActionButton;
}

type Props = OwnProps;

const BarAction: React.FC<Props> = (props) => {
  const { translate } = useContext(LocaleCtx);
  switch (props.items.length) {
    case 0:
      return <></>;
    case 1:
      const item = {
        ...props.items[0],
        ...props.root,
        onClick: props.items[0].onClick,
      };
      return buildButton(item, translate);
    default:
      const root = props.root || props.items[0];
      const { items } = props;
      return buildDropDownMenu(items, root, translate);
  }
};

export default BarAction;
